import { Component, OnInit, Input } from '@angular/core';

import { IAppConfig } from '../../store';
import { il8nDate, il8nDateNoYear } from '../../common';

import { Stay } from '../../api/model/reservation/stay.model';

@Component({
  selector: 'stay-mgmt-cancel-dates',
  templateUrl: './cancel-dates.component.html',
  styleUrls: ['./cancel-dates.component.scss']
})
export class CancelDatesComponent implements OnInit {
  @Input() messages;
  @Input() appConfig: IAppConfig;
  @Input() shortDayFormat;
  private _stay: Stay;

  formattedCheckInLong: any;
  formattedCheckInShort: any;
  formattedCheckOutLong: any;
  formattedCheckOutShort: any;
  formattedCheckInShortNoYear: any;
  formattedCheckOutShortNoYear: any;

  constructor() {
  }
  ngOnInit() {

  }

  @Input()
  set stay(stay: Stay) {
    if (stay) {
      this._stay = stay;
      this.setDates();
    }
  }
  get stay(): Stay {
    return this._stay;
  }

  setDates() {
    // format date for internationalization & viewport size
    const language = this.appConfig.language;
    const country = this.appConfig.country;

    this.formattedCheckInLong = il8nDate(this.stay.checkInDate, language, country);
    this.formattedCheckInShort = il8nDate(this.stay.checkInDate, language, country, 'short');

    this.formattedCheckOutLong = il8nDate(this.stay.checkOutDate, language, country);
    this.formattedCheckOutShort = il8nDate(this.stay.checkOutDate, language, country, 'short');

    this.formattedCheckInShortNoYear = il8nDateNoYear(this.stay.checkInDate, language, country, 'short').replace(' ', ', ');
    this.formattedCheckOutShortNoYear = il8nDateNoYear(this.stay.checkOutDate, language, country, 'short').replace(' ', ', ');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/cancel-dates/cancel-dates.component.ts